import { Check } from "lucide-react";

const STATUS_COLORS = {
  0: "bg-sky-600 shadow-100",
  undefined: "bg-gray-400",
};

const StageStatusIcon = ({ status }) => {
  if (status === 1) {
    return (
      <Check
        color="white"
        className="bg-green-3 rounded-full h-5 w-5 lg:h-7 lg:w-7 p-1"
      />
    );
  }

  return (
    <div
      className={`${STATUS_COLORS[status]} rounded-full h-5 w-5 lg:h-7 lg:w-7`}
    />
  );
};

export default StageStatusIcon;